@if (workspace(); as workspace) {
  <app-button2 appearance="secondary" size="m" rounding="lg" [ariaLabel]="label()" [title]="label()" (click)="open()">
    @if (workspace === 'team') {
      <span class="flex size-10 items-center justify-center rounded bg-secondary-200 text-sm">{{ initials() }}</span>
    } @else {
      <app-icon name="sapphire-lock" />
    }
    @if (!compact()) {
      <span>{{ workspace === 'team' ? identity()?.spaceTitle : 'My workspace' }}</span>
    }
    <app-icon name="sapphire-chevron-down" size="s" />
  </app-button2>
}
